import { getNode, PostType } from '@space-cow-media/wp-components'
import { useEffect, useState } from 'react'

import ArticlePreview from '../ArticlePreview/ArticlePreview'

type ReadMorePreviewProps = { url: string }

const ReadMorePreview = ({ url }: ReadMorePreviewProps) => {
  const [post, setPost] = useState<PostType>()

  useEffect(() => {
    const fetch = async () => {
      const postNode = await getNode(url)
      setPost(postNode as PostType)
    }

    fetch()
  }, [])

  if (!post) return

  return (
    <ArticlePreview
      author={post.author}
      date={post.date}
      excerpt={post.excerpt}
      featuredImageUrl={post.featuredImageUrl}
      slug={post.slug}
      tags={post.tags}
      title={post.title}
    />
  )
}

export default ReadMorePreview
